import {
  SET_FIELD,
  SET_GREETING,
  SET_WRAPPING,
  GET_PRODUCT_SINGLE_START,
  GET_PRODUCT_SINGLE_ERROR,
  GET_PRODUCT_SINGLE_SUCCESS,
  GET_PRODUCT_STOCK_INFO_START,
  GET_PRODUCT_STOCK_INFO_SUCCESS,
  GET_PRODUCT_STOCK_INFO_ERROR,
  SET_CURRENT_PRODUCT,
  SET_DELIVERY_METHOD,
  SET_CURRENCY_FILTER,
} from '../constants';
import productSingleQuery from './queries/productSingle.graphql';
import productStockInfo from './queries/getProductStockInfo.graphql';
import { getFromState } from '../helpers';

export function getProductStockInfo(id) {
  return async (dispatch, _, { client }) => {
    dispatch({
      type: GET_PRODUCT_STOCK_INFO_START,
    });

    try {
      const {
        data: {
          products: { stockInfo },
        },
        loading,
      } = await client.query({
        query: productStockInfo,
        variables: {
          id,
          context: {
            service: 'graphqlHost',
          },
        },
      });

      dispatch({
        type: GET_PRODUCT_STOCK_INFO_SUCCESS,
        payload: {
          stockInfo,
          loading,
        },
      });
    } catch (error) {
      dispatch({
        type: GET_PRODUCT_STOCK_INFO_ERROR,
        payload: {
          error,
          loading: false,
        },
      });
    }
  };
}
export function getProductSingle(id) {
  return async (dispatch, getState, { client }) => {
    const {
      intl: { locale, currency, countryCode },
      config: { salesChannelId },
      basket: { vouchers = [] } = {},
    } = getState();
    dispatch({
      type: GET_PRODUCT_SINGLE_START,
    });

    try {
      let associatedB2bDepartment;
      if (vouchers?.length) {
        const b2bIdSet = new Set();
        vouchers.forEach(current => {
          b2bIdSet.add(current.boughtByB2bDepartment);
        });
        // send associate b2bid only when all the vouchers has same b2b id
        const b2bIds = [...b2bIdSet];
        if (b2bIds.length === 1 || b2bIds.every(curr => !curr)) {
          associatedB2bDepartment = b2bIds.pop();
        }
      }
      const {
        data: { productSingle },
        loading,
      } = await client.query({
        query: productSingleQuery,
        variables: {
          input: {
            id,
            associatedB2bDepartment,
            salesChannelId,
            expectedLanguage: locale,
            expectedCurrency: currency,
          },
        },
        context: {
          service: 'cms',
        },
      });

      dispatch({
        type: GET_PRODUCT_SINGLE_SUCCESS,
        payload: {
          data: productSingle,
          countryCode,
          loading,
        },
      });
    } catch (error) {
      dispatch({
        type: GET_PRODUCT_SINGLE_ERROR,
        payload: {
          error,
          loading: false,
        },
      });
    }
    return getFromState(getState(), 'product');
  };
}

export const setCurrentProduct = ({
  value,
  sku,
  defaultPriceCurrency,
  price,
}) => ({
  type: SET_CURRENT_PRODUCT,
  payload: {
    giftcardValue: value,
    stockKeepingUnit: sku,
    valueCurrency: defaultPriceCurrency,
    productPurchasePrice: price,
  },
});

export function setCurrencyFilter({ currency }) {
  return async (dispatch, getState) => {
    const {
      product: {
        data: { deliveryMethods },
        formData: { deliveryMethod },
      },
    } = getState();
    dispatch({
      type: SET_CURRENCY_FILTER,
      payload: {
        currency,
      },
    });
    if (currency) {
      const { sku, defaultPrice, defaultPriceCurrency, price } =
        deliveryMethods[deliveryMethod].find(
          inventory => inventory.defaultPriceCurrency === currency,
        ) || {};

      if (sku) {
        dispatch(
          setCurrentProduct({
            value: defaultPrice,
            price,
            defaultPriceCurrency,
            sku,
          }),
        );
      }
    }
  };
}

export function setDeliveryMethod({ deliveryMethod }) {
  return async (dispatch, getState) => {
    const {
      product: { currencyFilter },
    } = getState();
    dispatch({
      type: SET_DELIVERY_METHOD,
      payload: {
        deliveryMethod,
      },
    });

    if (currencyFilter) {
      setCurrencyFilter({ currency: currencyFilter });
    }
  };
}

export const setField = (name, value) => ({
  type: SET_FIELD,
  payload: {
    name,
    value,
  },
});

export const setGreeting = greeting => ({
  type: SET_GREETING,
  payload: {
    ...greeting,
  },
});

export const setWrapping = wrapping => ({
  type: SET_WRAPPING,
  payload: {
    ...wrapping,
  },
});
